<template>
  <div id="app" @click="h5headerHideFn">
    <headers class="header" ref="head"></headers>
    <router-view class="app-content" />
    <footers></footers>
  </div>
</template>

<script>
import headers from "./components/header.vue";
import footers from "./components/footer.vue";
export default {
  name: "App",
  components: {
    headers,
    footers,
  },
  methods: {
    h5headerHideFn() {
      console.log(this.$refs.head.h5show);
      this.$refs.head.h5show = false;
      this.$refs.head.twoShow = false;
      // this.$children.h5show = false;
    },
  },
};
</script>

<style>
/* #0e9bad */
#app {
  padding-top: 150px;
}
/* .el-country-select */

@media screen and (max-width: 768px) {
  .el-select-dropdown {
    left: 10px !important;
    max-width: calc(100% - 20px) !important;
  }
}
.two-big-title {
  background-image: url("https://fhk.ais.cn/cms/website/editor/202309/371230926160255969.jpg");
  background-size: cover;
  height: 150px;
  text-align: center;
  line-height: 150px;
  font-size: 30px;
  color: #28d6ec;
}

.header {
  position: fixed;
  top: 0;
  width: 100%;
  right: 0;
  height: 150px;
  z-index: 999;
}

.people .el-carousel__arrow--left,
.people .el-carousel__arrow--right {
  top: 30%;
}

.index-swiper .el-carousel__arrow--left,
.index-swiper .el-carousel__arrow--right {
  top: 42%;
}

.cup {
  cursor: pointer;
}

.big-title {
  color: #28d6ec;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.big-title span {
  position: relative;
  font-size: 24px;
}

.big-title span::after {
  content: "";
  bottom: -10px;
  left: 10px;
  height: 4px;
  right: 10px;
  text-align: center;
  background: #28d6ec;
  position: absolute;
}

.reg-table .el-table--border td,
.reg-table .el-table--border th,
.reg-table
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed,
.reg-table .el-table--border,
.reg-table .el-table--group {
  border-color: #999 !important;
}

.reg-table .el-table--border {
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
}

.reg-table .el-table thead {
  color: #333;
}

* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  font-size: 16px;
  font-family: "Hiragino Sans GB", "Microsoft Yahei UI", "Microsoft Yahei",
    "微软雅黑", "Segoe UI", Tahoma, "宋体b8b\4f53", SimSun, sans-serif;
}

#app,
html,
body {
  width: 100%;
  height: 100%;
}

.u-line-1 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.u-line-2 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.u-line-3 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.el-drawer__header,
.el-drawer__header > :first-child {
  font-size: 22px !important;
  color: #000;
}
.el-drawer__close-btn {
  transform: scale(1.5);
}
.u-line-4 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .people-lists-contents.el-carousel--horizontal,
  .people-lists-contents .el-carousel__container {
    height: 200px;
    overflow: hidden;
  }
  #app {
    padding-top: 80px;
  }
  .el-carousel__container {
    height: 150px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue